import { Easy69_v1 } from "../frfr-easy69-utils";
import { _zzyourmap_lib_lookup_obj_vr_tablename_to_layer_title_auto, _zzyourmap_lib_lookup_obj_vr_tablename_to_tab_auto, _zzyourmap_lib_vr_tablename_values_ymblog, _zzyourmap_lib_vr_tablename_values_ymthing_to_enrich, _zzyourmap_lib_vr_tablename_values_ymthing_to_extract } from "./zz-yourmap-data-keys-and-values-lib";
import { _zzyourmap_img_url_full_from_parts } from "./zz-yourmap-image-utils";


// ----- functions


const _zzyourmap_convert_text_to_slug_fragment = (value) => {
  if (!Easy69_v1.is_string_not_empty(value)) {
    return '';
  }
  const serbianLatinChars = {
    'đ': 'dj',
    'ž': 'z',
    'ć': 'c',
    'č': 'c',
    'š': 's',
  };
  let slug = value.toLowerCase().trim();
  slug = slug.replace(/[đžćčš]/g, (match) => serbianLatinChars[match]);
  slug = slug.replace(/\s+/g, '-');
  slug = slug.replace(/[^a-z0-9-_]/g, '-');
  slug = slug.replace(/-+/g, '-');
  slug = slug.replace(/^-+|-+$/g, '');
  return slug;
};


const _zzyourmap_make_map_slug = (destination_slug, subdestination_title, is_main_subdestination) => {
  const safe_destination_slug = _zzyourmap_convert_text_to_slug_fragment(destination_slug);
  const safe_subdestination_slug = _zzyourmap_convert_text_to_slug_fragment(subdestination_title);
  if (!Easy69_v1.is_string_not_empty(safe_destination_slug)) {
    return '';
  }
  if (is_main_subdestination === true || !Easy69_v1.is_string_not_empty(safe_subdestination_slug) || safe_subdestination_slug === safe_destination_slug) {
    return safe_destination_slug;
  }
  return safe_destination_slug + '-' + safe_subdestination_slug;
};


//
export const _zzyourmap_extract_destination_main_img_url = (entity) => {
  const img_url_full = _zzyourmap_img_url_full_from_parts(entity?.destinacija_main_img_filename, entity?.destinacija_main_img_folder);
  return img_url_full;
};
//
const _zzyourmap_extract_smestaj_main_img_url = (entity) => {
  const img_url_full = _zzyourmap_img_url_full_from_parts(entity?.smestaj_main_img_filename, entity?.smestaj_main_img_folder);
  return img_url_full;
};


// -----


//
export const _yourmap_enrich_smestaj_entity = (item, lookup_pack, _is_public) => {
  const enriched_entity = { ...item };
  const img_url_full = _zzyourmap_extract_smestaj_main_img_url(item);
  enriched_entity._main_img_url = img_url_full;
  if (_is_public === true) {
    enriched_entity._is_public = true; // public entity
  } else {
    // admin only
  }

  //
  if (Easy69_v1.is_value_in_array(item.vr_tablename, _zzyourmap_lib_vr_tablename_values_ymthing_to_enrich)) { // CASE ymthing
    const slide_img_src_arr = [
      img_url_full,
      /*
      'https://ymdemo2.applabz.work/uploads/2025-12-02_img_692f8cbdef3df.jpg',
      'https://ymdemo2.applabz.work/uploads/2025-12-03_img_69311ee0d4666.jpg',
      'https://ymdemo2.applabz.work/uploads/2025-11-30_img_692d30787b512.jpg',
      'https://ymdemo2.applabz.work/uploads/2025-12-10_img_6939fac9c7c07.jpg',
      */
    ];
    if (Easy69_v1.is_array(item?.gallery_img_arr)) {
      item.gallery_img_arr.forEach(gallery_img => {
        slide_img_src_arr.push(_zzyourmap_img_url_full_from_parts(gallery_img, 'uploads'));
      });
    }
    enriched_entity._slide_img_src_arr = slide_img_src_arr;
    //
    // NOVO 2026-04-05 novo baratanje sa tabovima
    if (Easy69_v1.is_bool(enriched_entity.smestaj_tab_is_manual)) { // CASE already compatible
      // do nothing
    } else { // CASE old type
      // COMPATIBILITY FIX
      enriched_entity.smestaj_tab_is_manual = false; // default false for ymthings
    }
    enriched_entity._routing_tab = null;
    if (enriched_entity.smestaj_tab_is_manual === true) { // CASE tab is manual
      if (Easy69_v1.is_string_not_empty(enriched_entity.smestaj_tab)) {
        enriched_entity._routing_tab = enriched_entity.smestaj_tab;
      }
    } else { // CASE tab is automatic
      if (_zzyourmap_lib_lookup_obj_vr_tablename_to_tab_auto[item.vr_tablename]) {
        enriched_entity._routing_tab = _zzyourmap_lib_lookup_obj_vr_tablename_to_tab_auto[item.vr_tablename];
      }
    }
    //
    // NOVO 2026-04-25 novo baratanje sa layerima
    enriched_entity._marker_layer_title = null;
    if (enriched_entity.smestaj_layer_is_manual === true) { // CASE layer is manual
      // TODO
      if (enriched_entity.smestaj_layer_is_custom === true) { // CASE layer is custom title
        if (Easy69_v1.is_string_not_empty(enriched_entity.smestaj_layer_custom_title)) {
          enriched_entity._marker_layer_title = enriched_entity.smestaj_layer_custom_title;
          enriched_entity.smestaj_layer = null;
        }
      } else { // CASE layer is selected
        if (Easy69_v1.is_string_not_empty(enriched_entity.smestaj_layer)) { // valid
          enriched_entity._marker_layer_title = enriched_entity.smestaj_layer;
        }
      }
    } else { // CASE layer is automatic
      if (_zzyourmap_lib_lookup_obj_vr_tablename_to_layer_title_auto[item.vr_tablename]) {
        enriched_entity._marker_layer_title = _zzyourmap_lib_lookup_obj_vr_tablename_to_layer_title_auto[item.vr_tablename];
      }
    }
    //
    //
  } else if (Easy69_v1.is_value_in_array(item.vr_tablename, _zzyourmap_lib_vr_tablename_values_ymblog)) { // CASE ym_table_ostalo_v1 ymblog
    //
    // NOVO 2026-04-25 novo baratanje sa tabovima
    if (Easy69_v1.is_bool(enriched_entity.smestaj_tab_is_manual)) { // CASE already compatible
      // do nothing
    } else { // CASE old type
      // COMPATIBILITY FIX
      enriched_entity.smestaj_tab_is_manual = true; // default true for ymblog
    }
    enriched_entity.smestaj_tab_is_manual = true; // UVEK TRUE for ymblog
    enriched_entity._routing_tab = null;
    if (enriched_entity.smestaj_tab_is_manual === true) { // CASE tab is manual
      if (Easy69_v1.is_string_not_empty(enriched_entity.smestaj_tab)) {
        enriched_entity._routing_tab = enriched_entity.smestaj_tab;
      }
    } else { // CASE tab is automatic
      enriched_entity._routing_tab = null; // default bez taba za ymblog
    }
    //
    // NOVO 2026-04-25 novo baratanje sa layerima
    enriched_entity._marker_layer_title = null;
    enriched_entity.smestaj_layer_is_manual = true; // UVEK TRUE I readonly
    if (enriched_entity.smestaj_layer_is_manual === true) { // CASE layer is manual
      // TODO
      if (enriched_entity.smestaj_layer_is_custom === true) { // CASE layer is custom title
        if (Easy69_v1.is_string_not_empty(enriched_entity.smestaj_layer_custom_title)) {
          enriched_entity._marker_layer_title = enriched_entity.smestaj_layer_custom_title;
          enriched_entity.smestaj_layer = null;
        }
      } else { // CASE layer is selected
        if (Easy69_v1.is_string_not_empty(enriched_entity.smestaj_layer)) { // valid
          enriched_entity._marker_layer_title = enriched_entity.smestaj_layer;
        }
      }
    } else { // CASE layer is automatic
      if (_zzyourmap_lib_lookup_obj_vr_tablename_to_layer_title_auto[item.vr_tablename]) {
        enriched_entity._marker_layer_title = _zzyourmap_lib_lookup_obj_vr_tablename_to_layer_title_auto[item.vr_tablename];
      }
    }
    //
    //
  }
  //
  // i za jedno i za drugo
  if (Easy69_v1.is_value_in_array(item.vr_tablename, _zzyourmap_lib_vr_tablename_values_ymthing_to_enrich) || Easy69_v1.is_value_in_array(item.vr_tablename, _zzyourmap_lib_vr_tablename_values_ymblog)) {
    //
    //
    enriched_entity._routing_parent_real_destination_id = '?';
    enriched_entity._routing_parent_real_destination_slug = '?';
    enriched_entity._routing_parent_subdestination_id_for_map = null;
    enriched_entity._routing_parent_subdestination_id = null;
    ////
    /*
    const {
      lookup_obj_slug_to_id,
      lookup_obj_id_to_slug,
      lookup_obj_parent_destination_to_real_destination,
    } = lookup_pack;
    */
    if (lookup_pack.lookup_obj_parent_destination_to_real_destination) {
      enriched_entity._routing_parent_real_destination_id = lookup_pack.lookup_obj_parent_destination_to_real_destination[item.parent_destinacija_id];
      if (lookup_pack.lookup_obj_id_to_slug) {
        enriched_entity._routing_parent_real_destination_slug = lookup_pack.lookup_obj_id_to_slug[enriched_entity._routing_parent_real_destination_id];
      }
      if (item.parent_destinacija_id === enriched_entity._routing_parent_real_destination_id) { // CASE parent is main destination
        enriched_entity._routing_parent_subdestination_id_for_map = null;
        enriched_entity._routing_parent_subdestination_id = enriched_entity._routing_parent_real_destination_id;
      } else { // CASE parent is subdestination
        enriched_entity._routing_parent_subdestination_id_for_map = item.parent_destinacija_id;
        enriched_entity._routing_parent_subdestination_id = item.parent_destinacija_id;
      }
    }
    ////
    //
    //
  }
  //
  //
  //
  return enriched_entity;
};


//
const _enrich_destination_entities_with_subdestinatons = (destination_entities, subdestination_entities) => {
  //
  // STEP *)
  const enriched_destination_entities = [];
  const enriched_destination_entities_adm = [];
  // let options_adm_parent_of_destination = [];
  // let options_adm_parent_of_smestaj = []; // TODO
  destination_entities.forEach((item, index) => {
    const enriched_destination_entity = {
      ...item,
    };
    let _item_is_destination = false;
    if (item.destinacija_tip === "DESTINATION") {
      _item_is_destination = true;
    }
    if (_item_is_destination === true) {
      // STEP 2) enrich destination with main subdestination
      enriched_destination_entity._subdestinations = [];
      // enriched_destination_entity._subdestinations_ids = [];
      const subdestination_id = item.of_id;
      const destinacija_poddestinacija_naslov = item.destinacija_poddestinacija_naslov;
      const destinacija_slug = item.destinacija_slug;
      // const destinacija_slug = item.destinacija_slug;
      // let _option_title = destinacija_slug;
      const _option_title = item.destinacija_naslov + ' (' + item.destinacija_poddestinacija_naslov + ')';
      const _option_value_for_map = null;
      const destination_id = item.of_id;
      const _option_value_regular = destination_id;
      const _map_slug = _zzyourmap_make_map_slug(destinacija_slug, destinacija_poddestinacija_naslov, true);
      const _map_img_url = _zzyourmap_img_url_full_from_parts(item?.destinacija_map_img_filename, item?.destinacija_map_img_folder);
      const _map_img_w = item.destinacija_map_img_w;
      const _map_img_h = item.destinacija_map_img_h;
      // add destination as main destination
      enriched_destination_entity._subdestinations.push({
        // ...item,
        _is_subdestionation: true,
        _is_main_subdestionation: true,
        _option_title,
        _option_value_for_map,
        _option_value_regular,
        _map_slug,
        _map_img_url,
        _map_img_w,
        _map_img_h,
        of_id: subdestination_id,
        destinacija_poddestinacija_naslov,
        _debug_frontend: true,
      });
      // enriched_destination_entity._subdestinations_ids.push(null);
      const _main_img_url = _zzyourmap_extract_destination_main_img_url(item);
      enriched_destination_entity._main_img_url = _main_img_url;
      //
      // STEP 3) enrich destination with other subdestinations
      subdestination_entities.forEach((subdestination_item, i) => {
        if (subdestination_item?.destinacija_tip === "SUBDESTINATION" && subdestination_item?.parent_destinacija_id > 0 && subdestination_item?.parent_destinacija_id === item.of_id) { // BINGO
          if (subdestination_item._master_flag_deleted === true) {
            // skip
          } else {
            const subdestination_id = subdestination_item.of_id;
            const destinacija_poddestinacija_naslov = subdestination_item.destinacija_poddestinacija_naslov;
            const _option_title = subdestination_item.destinacija_poddestinacija_naslov;
            const _option_value_for_map = subdestination_id;
            const _map_slug = _zzyourmap_make_map_slug(item.destinacija_slug, destinacija_poddestinacija_naslov, false);
            const _map_img_url = _zzyourmap_img_url_full_from_parts(subdestination_item?.destinacija_map_img_filename, subdestination_item?.destinacija_map_img_folder);
            ////
            const _map_img_w = subdestination_item.destinacija_map_img_w;
            const _map_img_h = subdestination_item.destinacija_map_img_h;
            enriched_destination_entity._subdestinations.push({
              ...subdestination_item,
              _is_subdestionation: true,
              // _is_main_subdestionation: false,
              _option_title,
              _option_value_for_map,
              _option_value_regular: _option_value_for_map,
              _map_slug,
              _map_img_url,
              _map_img_w,
              _map_img_h,
              // _main_img_url,
              of_id: subdestination_id,
              destinacija_poddestinacija_naslov,
            });
            // enriched_destination_entity._subdestinations_ids.push(subdestination_item.parent_destinacija_id);
          }
        }
      });
    }
    //
    // return enriched_destination_entity;
    if (item._master_flag_deleted === true) {
      // skip
    } else {
      if (_item_is_destination === true) {
        enriched_destination_entities.push(enriched_destination_entity);
      }
    }
    enriched_destination_entities_adm.push(enriched_destination_entity);
  });
  //
  return {
    enriched_destination_entities,
    enriched_destination_entities_adm,
  };
};


// TODO v3 novo da obavi samo destiancije... pa sledeci korak je da moze sa njima da se enrichuju things entities da se zna da li pripadaju ruti ili ne
const _zzyourmap_multitable_extract_destinations_entities_v3 = (entities) => {
  // // let destination_entities = [];
  let subdestination_entities = []; // TODO
  let destination_entities_adm = [];
  // let options_adm_parent_of_destination = [];
  console.log('* entities', entities);
  if (Easy69_v1.is_array(entities)) {
    // console.log('entities', entities);
    entities.forEach((item, index) => {
      // let decoded = {};
      if (item.vr_tablename === 'ym_table_destination') {
        if (item._master_flag_deleted === true) {
          // skip
        } else {
          if (item.destinacija_tip === "DESTINATION") {
            // destination_entities.push({ ...item });
          } else if (item.destinacija_tip === "SUBDESTINATION") {
            subdestination_entities.push({ ...item });
          }
        }
        destination_entities_adm.push({ ...item });
        //
      }
    }); // end of forEach
    // sort destiantion - priority kopaonik
    destination_entities_adm = Easy69_v1.sort_advanced(destination_entities_adm, (item) => { return item?.destinacija_slug }, true, ['kopaonik']);
    // console.log('destination_entities', destination_entities);
    // console.log('subdestination_entities', subdestination_entities);
    console.log('destination_entities_adm SORTED', destination_entities_adm);
    //
  }
  //
  const {
    enriched_destination_entities,
    enriched_destination_entities_adm,
  } = _enrich_destination_entities_with_subdestinatons(destination_entities_adm, subdestination_entities);
  console.log('ENRICHED enriched_destination_entities', enriched_destination_entities);
  console.log('ENRICHED enriched_destination_entities_adm', enriched_destination_entities_adm);
  const {
    lookup_obj_slug_to_id,
    lookup_obj_id_to_slug,
    lookup_obj_parent_destination_to_real_destination,
  } = _zzyourmap_extract_lookups(enriched_destination_entities);
  const lookup_pack = {
    lookup_obj_slug_to_id,
    lookup_obj_id_to_slug,
    lookup_obj_parent_destination_to_real_destination,
  };
  //
  return {
    destination_entities: enriched_destination_entities,
    destination_entities_adm: enriched_destination_entities_adm,
    lookup_pack,
  };
};


// TODO
const _zzyourmap_extract_lookups = (destination_entities) => {
  let lookup_obj_slug_to_id = {};
  let lookup_obj_id_to_slug = {};
  let lookup_obj_parent_destination_to_real_destination = {};
  if (Array.isArray(destination_entities)) {
    // console.log('entities', entities);
    destination_entities.forEach((item, index) => {
      if (item.vr_tablename === 'ym_table_destination') {
        if (item._master_flag_deleted === true) {
          // skip
        } else {
          // if (item._is_main_subdestionation === true) { // CASE DESTINATION
          if (true) { // CASE DESTINATION
            //
            if (item.of_id > 0) {
              const real_destination_id = item.of_id;
              //
              lookup_obj_parent_destination_to_real_destination[real_destination_id] = real_destination_id;
              if (Easy69_v1.is_array(item._subdestinations)) {
                item._subdestinations.forEach((subdestination_item) => {
                  const parent_destinacija_id = subdestination_item._option_value_regular;
                  lookup_obj_parent_destination_to_real_destination[parent_destinacija_id] = real_destination_id;
                  if (Easy69_v1.is_string_not_empty(subdestination_item._map_slug)) {
                    lookup_obj_slug_to_id[subdestination_item._map_slug] = real_destination_id;
                  }
                });
              }
              //
              lookup_obj_slug_to_id[real_destination_id] = real_destination_id;
              if (Easy69_v1.is_string_not_empty(item.destinacija_slug)) {
                const destinacija_slug = item.destinacija_slug;
                lookup_obj_slug_to_id[destinacija_slug] = real_destination_id;
                lookup_obj_id_to_slug[real_destination_id] = destinacija_slug;
              } else {
                lookup_obj_id_to_slug[real_destination_id] = real_destination_id;
              }
            }
            //
          }
        }
      }
    }); // end of foreach
  }
  //
  return {
    lookup_obj_slug_to_id,
    lookup_obj_id_to_slug,
    lookup_obj_parent_destination_to_real_destination,
  };
};


// TODO v3
// TODO v4
const _zzyourmap_multitable_extract_things_entities_v4 = (entities, lookup_pack) => {
  // let current_destination_entity = {};
  // let current_smestaj_entity = {};
  // let current_restoran_entity = {}; // TODO ZA SADA JE SAMO PLACEHOLDER
  // // let destination_entities = [];
  // let subdestination_entities = []; // TODO
  // let destination_entities_adm = [];
  let ymthing_entities = [];
  let ymthing_entities_adm = [];
  // let smestaj_entities = [];
  // let smestaj_entities_adm = [];
  // let restoran_entities = [];
  // let restoran_entities_adm = [];
  let ymostalo_v1_entities = [];
  let ymostalo_v1_entities_adm = [];
  // let markerable_entities = [];
  // let options_adm_parent_of_destination = [];
  console.log('* entities', entities);
  if (Easy69_v1.is_array(entities)) {
    // console.log('entities', entities);
    entities.forEach((item, index) => {
      // let decoded = {};
      let _is_public = true;
      if (item._master_flag_deleted === true) {
        _is_public = false;
      }
      //
      if (item.vr_tablename === 'ym_table_destination') {
        // already extracted
      } else if (Easy69_v1.is_value_in_array(item.vr_tablename, _zzyourmap_lib_vr_tablename_values_ymthing_to_extract)) {
        const enriched_item = _yourmap_enrich_smestaj_entity(item, lookup_pack, _is_public);
        if (_is_public === false) {
          // skip
        } else {
          ymthing_entities.push(enriched_item);
          // if (enriched_item.smestaj_marker_enabled === true) { markerable_entities.push(enriched_item); }
        }
        ymthing_entities_adm.push(enriched_item);
      } else if (item.vr_tablename === 'ym_table_ignored') {
        const enriched_item = _yourmap_enrich_smestaj_entity(item, lookup_pack, _is_public);
        if (_is_public === false) {
          // skip
        } else {
          ymthing_entities.push(enriched_item);
        }
        ymthing_entities_adm.push(enriched_item);
        // } else if (item.vr_tablename === 'ym_table_ostalo_v1') {
      } else if (Easy69_v1.is_value_in_array(item.vr_tablename, _zzyourmap_lib_vr_tablename_values_ymblog)) {
        const enriched_item = _yourmap_enrich_smestaj_entity(item, lookup_pack, _is_public);
        if (_is_public === false) {
          // skip
        } else {
          ymostalo_v1_entities.push(enriched_item);
          // ymthing_entities.push(enriched_item); // TODO
          // if (enriched_item.smestaj_marker_enabled === true) { markerable_entities.push(enriched_item); }
        }
        ymostalo_v1_entities_adm.push(enriched_item);
      }
    }); // end of forEach
    // console.log('current_destination_entity', current_destination_entity);
    // console.log('current_smestaj_entity', current_smestaj_entity);
    // console.log('destination_entities', destination_entities);
    // console.log('subdestination_entities', subdestination_entities);
    // console.log('destination_entities_adm SORTED', destination_entities_adm);
    console.log('ymthing_entities', ymthing_entities);
    console.log('ymthing_entities_adm', ymthing_entities_adm);
    console.log('ymostalo_v1_entities', ymostalo_v1_entities);
    // console.log('markerable_entities', markerable_entities);
    //
  }
  //
  return {
    // current_destination_entity,
    // current_smestaj_entity,
    // destination_entities: enriched_destination_entities,
    // destination_entities_adm: enriched_destination_entities_adm,
    // subdestination_entities,
    ymthing_entities,
    ymthing_entities_adm,
    ymostalo_v1_entities,
    ymostalo_v1_entities_adm,
    // markerable_entities,
    // options_adm_parent_of_destination,
    // options_adm_parent_of_smestaj,
  };
};


// FINAL
export const _zzyourmap_extract_tables_from_multitable_entities_v3 = (entities) => {
  //
  // STEP 1)
  const {
    destination_entities, // ENRICHED destination_entities
    destination_entities_adm, // ENRICHED destination_entities_adm
    lookup_pack,
  } = _zzyourmap_multitable_extract_destinations_entities_v3(entities);
  //
  // STEP 2)
  const {
    ymthing_entities,
    ymthing_entities_adm,
    ymostalo_v1_entities,
    ymostalo_v1_entities_adm,
    // markerable_entities,
  } = _zzyourmap_multitable_extract_things_entities_v4(entities, lookup_pack);
  //
  // STEP *)
  //
  const separated_entities_pack = {
    destination_entities,
    destination_entities_adm,
    ymthing_entities,
    ymthing_entities_adm,
    ymostalo_v1_entities,
    ymostalo_v1_entities_adm,
    // markerable_entities,
    //
    lookup_pack,
  };
  return separated_entities_pack;
};

